import ActivityLog from "@shared-models/profile/activity.log.model";
import axios from "@shared/axios";
import TableColumnFilterInterface from "@shared-interfaces/table.column.filter.interface";
import TableColumnSortInterface from "@shared-interfaces/table.column.sort.interface";
import { formatQuery } from "@/utils/table.utils";
import ActivityLogHistoryInterface from "@shared-interfaces/profile/activity.log.history.interface";

/** @deprecated */
async function getActivitiesLog(
	sorting: TableColumnSortInterface[] = [],
	filtering: TableColumnFilterInterface[] = [],
	limit?: number): Promise<ActivityLog[]>
{
	const query = formatQuery(sorting, filtering, limit);
	const response = await axios.get(
		"/admin/profile/activity-logs",
		query
	);

	return response?.data as ActivityLog[] ?? [];
}

async function getActivityLogHistory(selectedUser?: string | null, lastUlid: string | null | undefined = null, selectedCategoryKeys: string[] = [], limit: string = "40"): Promise<ActivityLogHistoryInterface>
{
	const params: Record<string, string | string[]> = {};

	if (selectedUser)
	{
		params.user = selectedUser;
	}

	if (lastUlid)
	{
		params.lastUlid = lastUlid;
	}

	if (selectedCategoryKeys.length > 0)
	{
		params.selectedCategoryKeys = selectedCategoryKeys;
	}

	params.limit = limit;

	const response = await axios.get(
		"/admin/profile/activity-logs",
		{ params }
	);

	return response?.data as ActivityLogHistoryInterface ?? { data: {}, total: 0 };
}

export {
	getActivityLogHistory,
	getActivitiesLog
};
